import { TERMINAL_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: TERMINAL_MNG,
  relationSearch: true,
  allowStatus: {},
  sortArr: [
    {
      fieldName: 'updateTime',
      direction: 'DESC'
    }
  ],
  toolbar: {
    searchPlaceholder: '请输入终端型号',
    moreBtnWidth: 160,
    searchFieldNameArr: ['model'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'terminalCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '品牌名称',
          prop: 'manufacturer',
          sortField: 'manufacturer'
        }
      },
      {
        props: {
          label: '终端型号',
          prop: 'model',
          sortField: 'model',
          width: 180
        }
      },
      {
        props: {
          label: '终端类型',
          prop: 'type',
          sortField: 'type'
        }
      },
      {
        props: {
          label: 'CPU型号',
          prop: 'cpu',
          sortField: 'cpu'
        }
      },
      {
        props: {
          label: 'CPU核数',
          prop: 'cpuCore',
          sortField: 'cpuCore'
        }
      },
      {
        props: {
          label: 'CPU频率',
          prop: 'cpuFrequency',
          sortField: 'cpuFrequency'
        }
      },
      {
        props: {
          label: '内存信息',
          prop: 'memory',
          sortField: 'memory'
        }
      },
      {
        props: {
          label: '硬盘大小',
          prop: 'diskSize',
          sortField: 'diskSize'
        }
      },
      {
        props: {
          label: '硬盘数量',
          prop: 'diskCount',
          sortField: 'diskCount'
        }
      },
      {
        props: {
          label: '显卡型号',
          prop: 'gpuModel',
          sortField: 'gpuModel'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'terminalEdit',
        name: 'edit'
      }
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'terminalDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.terminalMng.deleteMsg'
      //   }
      // }
    ]
  }
}
